export const anyCreatorUrl = 'https://any-creator.com';
